import Pusher from "pusher-js";

export const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
  cluster: "ap1",
  wsHost: process.env.VUE_APP_PUSHER_WS_HOST,
  wsPort: Number(process.env.VUE_APP_PUSHER_WS_PORT) || 6001,
  wssPort: Number(process.env.VUE_APP_PUSHER_WSS_PORT) || 443,
  forceTLS: process.env.VUE_APP_PUSHER_FORCE_TLS === "true",
  enabledTransports: ["ws", "wss"]
});
